import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resumin--disable-button-on-submit"
export default class extends Controller {
  connect() {
    this.element.addEventListener("submit", this.disableButtons.bind(this));
    this.enableButtons();
  }

  disconnect() {
    this.element.removeEventListener("submit", this.disableButtons.bind(this));
  }

  disableButtons(e) {
    // このコントローラー以外のbuttonも無効化する
    const buttons = document.querySelectorAll("button[type='submit']");
    buttons.forEach((button) => {
      button.setAttribute(
        "data-resumin--disable-button-on-submit-managed",
        "true"
      );
      button.setAttribute("disabled", "true");

      const addClass =
        button.dataset["resumin-DisableButtonOnSubmitSubmittedClassValue"];

      if (addClass) {
        button.classList.add(addClass);
      }
    });
  }

  enableButtons() {
    const buttons = document.querySelectorAll(
      "button[type='submit'][data-resumin--disable-button-on-submit-managed='true']"
    );
    buttons.forEach((button) => {
      button.removeAttribute("disabled");
      button.removeAttribute("data-resumin--disable-button-on-submit-managed");

      const addClass =
        button.dataset["resumin-DisableButtonOnSubmitSubmittedClassValue"];

      if (addClass) {
        button.classList.remove(addClass);
      }
    });
  }
}
